<template>
  <div class="container-fluid card-tela-principal d-flex flex-column fill-height">
    <v-card tile elevation="1" v-show="isSlaughterScheduleSelected" class="stick-bar">
      <v-layout justify-space-between align-center row ma-0 mt-1 pa-2>
        <v-flex lg2>
          <span class="title-programacao">{{ programmingTitle }}</span>
        </v-flex>
        <v-flex lg8 pr-2 pl-2>
          <v-tabs v-model="tab" grow align-with-title slider-color="primary">
            <v-tab class="font-size-08">Semana</v-tab>
            <v-tab
              :class="[{
                'btn-laranja': programacaoAbateSelected.cdStatusProgramacaoAbate == 1
              }]"
              :disabled="programacaoAbateSelected.cdStatusProgramacaoAbate < 1"
              class="font-size-08"
            >Demanda</v-tab>
            <v-tab
              :class="[{
                'btn-laranja': programacaoAbateSelected.cdStatusProgramacaoAbate == 2
              }]"
              :disabled="programacaoAbateSelected.cdStatusProgramacaoAbate < 2"
              class="font-size-08"
            >Lote</v-tab>
            <v-tab
              :class="[{
                'btn-laranja': programacaoAbateSelected.cdStatusProgramacaoAbate == 3
              }]"
              :disabled="programacaoAbateSelected.cdStatusProgramacaoAbate < 3"
              class="font-size-08"
            >Programação</v-tab>
            <v-tab
              :class="[{
                'btn-laranja': programacaoAbateSelected.cdStatusProgramacaoAbate == 4
              }]"
              :disabled="programacaoAbateSelected.cdStatusProgramacaoAbate < 4"
              class="font-size-08"
            >Turno de abate</v-tab>
          </v-tabs>
        </v-flex>
        <v-flex lg2 pl-0 pr-0 >
          <v-row justify="end" class="ma-0">
            <div v-if="tab === 1">
<!--              || programacaoAbateSelected.cdStatusProgramacaoAbate === 5-->
              <v-btn
                v-if="demandSaved && !canEditDemands"
                :disabled="confirmDemandDisabled "
                color="secondary"
                @click="setCanEditDemands"
              >Editar</v-btn>
<!--              || programacaoAbateSelected.cdStatusProgramacaoAbate === 5-->
              <v-btn
                v-else
                color="primary"
                :disabled="confirmDemandDisabled "
                @click="confirmarAlteracao"
              >Confirmar</v-btn>
            </div>
            <v-btn
              v-else
              :disabled="confirmBtnIsDisabled"
              color="primary"
              @click="confirmarAlteracao"
            >
              <span v-if="tab === 2" class="text-button-confirmar-lotes">Confirmar previsão</span>
              <span v-else class="text-button-confirmar-lotes">Confirmar</span>
            </v-btn>
          </v-row>
        </v-flex>
      </v-layout>
    </v-card>
    <div v-if="tab === 0" class="fill-height">
      <slaughter-schedule-week />
    </div>
    <div v-if="isSlaughterScheduleSelected" class="fill-height">
      <div v-show="tab === 1" class="fill-height">
        <Demanda
          :listaDatas="listaDatas"
          :demandSaved="demandSaved"
          :confirmarDemanda="confirmarDemanda"
        />
      </div>
      <div v-show="tab === 2">
        <Lotes :confirmarLotes.sync="confirmarLotes" @cancelConfirmarLotes="cancelConfirmarLotes" />
      </div>
      <div v-show="tab === 3">
        <Programacao
          :confirmarProgramacao="confirmarProgramacao"
          @cancelConfirmarProgramacao="cancelConfirmarProgramacao"
        />
      </div>
      <div v-show="tab === 4">
        <Carregamento
          :confirmarCarregamento.sync="confirmarCarregamento"
          @cancelConfirmarCarregamento="cancelConfirmarCarregamento"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { SlaughterProgrammingStepsEventBus } from "@/modules/programacaoAbate/events";
import {
  dateIsoToLocal,
  dateLocalToIso,
  dateTimeIsoToLocal,
  daysBetweenDates,
} from "@/filters/utils";
import SelectDate from "@/components/general/SelectDate.vue";
import Demanda from "../components/Demanda.vue";
import Lotes from "../components/Lotes";
import Programacao from "../components/Programacao.vue";
import Carregamento from "../components/Carregamento.vue";
import SlaughterScheduleWeek from "@/modules/programacaoAbate/components/WeekTab/SlaughterScheduleWeek";
import moment from "moment"

export default {
  name: "ProgramacaoAbate",
  components: {
    SlaughterScheduleWeek,
    SelectDate,
    Demanda,
    Lotes,
    Programacao,
    Carregamento,
  },
  provide() {
    return {
      _Tab: () => this.tab,
      _Stepper: () => this.stepper,
    };
  },
  computed: {
    confirmDemandDisabled() {
      let valid = false;
      this.listaDemandasPlanta.forEach((demand) => {
        this.listaDatas.forEach((data) => {
          if (demand[data.value]) valid = true;
        });
      });
      return !valid;
    },
    confirmBtnIsDisabled() {
      if (this.tab === 4) {
        const dtFimAbate = moment(this.programacaoAbateSelected.dtFimAbate)
        return moment(moment.now()).isAfter(dtFimAbate)
      } else {
        // return this.programacaoAbateSelected.cdStatusProgramacaoAbate === 5
        return false
      }
    },
    ...mapState("programacaoAbate", [
      "programmingTitle",
      "listaDatas",
      "demandSaved",
      "isSlaughterScheduleSelected",
      "listaDemandasPlanta",
      "programacaoAbateSelected",
      "canEditDemands",
    ]),
  },
  watch: {
    tab(newValue) {},
  },
  data() {
    return {
      confirmarDemanda: false,
      confirmarLotes: false,
      confirmarProgramacao: false,
      confirmarCarregamento: false,
      tab: null,
      stepper: {
        confirmButtonLabel: "Confirmar",
        confirmButtonDisabled: false,
        callback: () => {},
        confirmButtonFunc: this.onConfirmButtonClick,
        confirmButtonColor: "primary",

        setBtnOptions: (options) => {
          this.$set(
            this.stepper,
            "confirmButtonLabel",
            options.confirmButtonLabel
          );
          this.$set(
            this.stepper,
            "confirmButtonColor",
            options.confirmButtonColor
          );
        },
        setTab: this.setTab,
      },
    };
  },
  created() {
    SlaughterProgrammingStepsEventBus.$on("set-step", this.onSetStep);
    this.$store.dispatch("actLoadMunicipios");
    this.$store.dispatch("actLoadPlantasAbate");
  },
  methods: {
    daysBetweenDates,
    dateLocalToIso,
    dateIsoToLocal,
    dateTimeIsoToLocal,
    ...mapActions("programacaoAbate", [
      "ActionInserirDemandaBatch",
      "ActionAlterarDemandaBatch",
      "ActionLoadDemands",
      "ActionConfirmarLotes",
      "ActionSetCanEditDemands",
    ]),
    async confirmarAlteracao() {
      if (this.tab === 1) {
        if (this.demandSaved) {
          await this.ActionAlterarDemandaBatch(this.listaDemandasPlanta);
          this.ActionLoadDemands(
            this.programacaoAbateSelected.idProgramacaoAbate
          ).then(() => {
            this.ActionSetCanEditDemands(false);
            this.tab = 2;
          });
        } else {
          this.ActionInserirDemandaBatch(this.listaDemandasPlanta).then(() => {
            this.ActionSetCanEditDemands(false);
            this.ActionConfirmarLotes(2);
            this.ActionLoadDemands(
              this.programacaoAbateSelected.idProgramacaoAbate
            );
            this.tab = 2;
          });
        }
      } else if (this.tab == 2) {
        this.confirmarLotes = true;
      } else if (this.tab == 3) {
        this.confirmarProgramacao = true;
      } else if (this.tab == 4) {
        this.confirmarCarregamento = true;
      }
    },
    cancelConfirmarLotes() {
      this.confirmarLotes = false;
    },
    cancelConfirmarProgramacao() {
      this.confirmarProgramacao = false;
    },
    cancelConfirmarCarregamento() {
      this.confirmarCarregamento = false;
    },
    setCanEditDemands() {
      this.ActionSetCanEditDemands(true);
    },
    onSetStep(step) {
      this.tab = step;
    },

    onConfirmButtonClick() {
      this.stepper.callback();
    },
    setTab(tab) {
      this.tab = tab;
    },
  },
};
</script>

<style lang="scss">
@import "../sass/common";

.stick-bar {
  position: sticky !important;
  top: 0 !important;
  left: 0 !important;
}
</style>
